<template>

  <div class="feedItem panel bg-lightest black">
    <div class="w-100 font-weight-600"><span class="ml-1">Occupancy Alert</span></div>
    <div class="px-4 py-5 d-flex align-items-end h-100">
      <div class="w-50">
        <div class="fs-larger font-weight-600">{{cardInfo.productName}}</div>
        <div>{{cardInfo.date}}</div>
        <div class="color-6 font-weight-600">Only {{cardInfo.percentAvaliable}}% available</div>
      </div>
      <div class="w-50 d-flex flex-row-reverse">
        <div class="text-right">
          <div class="medium fs-small dark text-center mb-1">{{cardInfo.ticketRemaining}} tickets</div>
          <div class="ticketGraph bg-light d-flex">
            <div class="graphBar align-self-end bg-color-6 w-100" :style="{'height':cardInfo.percentAvaliable+'%'}"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  data: function() {
    return{
    }
  },
  props: {
    cardInfo: {
      type: Object
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  .panel{
    height: 214px !important;
  }

  .ticketGraph{
    width: 59px;
    height: 110px;

  }

</style>



// WEBPACK FOOTER //
// FeedcardOccupancy.vue?6dbea6ab